
import { motion } from 'framer-motion';
import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';

export default function CgvPage() {
  const sections = [
    {
      title: '1. Objet',
      content: 'Les présentes Conditions Générales de Vente (CGV) régissent les relations contractuelles entre Pixel-anim et tout client souhaitant effectuer un achat de créations numériques personnalisées via notre site web. Toute commande implique l\'acceptation sans réserve des présentes CGV.'
    },
    {
      title: '2. Produits et Services',
      content: 'Pixel-anim propose des créations numériques personnalisées incluant : livres numériques personnalisés, personnages de dessins animés, vidéos animées, invitations personnalisées, portraits illustrés et avatars. Tous les produits sont livrés au format numérique (PDF, JPG, MP4) par email ou téléchargement.'
    },
    {
      title: '3. Commandes',
      content: 'Pour passer commande, le client doit sélectionner le produit souhaité, remplir le questionnaire de personnalisation et procéder au paiement. La commande est confirmée par email avec un récapitulatif détaillé. Le client dispose d\'un délai de 14 jours pour exercer son droit de rétractation avant le début de la création.'
    },
    {
      title: '4. Prix et Paiement',
      content: 'Les prix sont indiqués en euros TTC. Le paiement s\'effectue en ligne de manière sécurisée via Stripe. Les moyens de paiement acceptés sont : cartes bancaires (Visa, Mastercard, American Express) et autres méthodes proposées par Stripe. Le paiement est exigible immédiatement à la commande.'
    },
    {
      title: '5. Délais de Livraison',
      content: 'Les délais de livraison varient selon le type de produit : 3-5 jours ouvrés pour les livres personnalisés, 5-7 jours pour les portraits illustrés, 7-10 jours pour les vidéos animées. Ces délais sont donnés à titre indicatif et peuvent varier selon la complexité de la personnalisation.'
    },
    {
      title: '6. Droit de Rétractation',
      content: 'Conformément à la législation en vigueur, le client dispose d\'un délai de 14 jours pour exercer son droit de rétractation sans avoir à justifier de motifs. Ce droit ne peut être exercé une fois que la création personnalisée a commencé, le client ayant expressément accepté de renoncer à ce droit lors de la validation de sa commande.'
    },
    {
      title: '7. Modifications et Révisions',
      content: 'Chaque commande inclut jusqu\'à 2 révisions mineures gratuites (corrections de texte, ajustements de couleurs). Les modifications majeures ou révisions supplémentaires peuvent faire l\'objet de frais additionnels. Les demandes de modification doivent être formulées dans les 7 jours suivant la réception du premier aperçu.'
    },
    {
      title: '8. Propriété Intellectuelle',
      content: 'Le client acquiert un droit d\'usage personnel et non commercial des créations. Pixel-anim conserve tous les droits de propriété intellectuelle sur les créations. Toute utilisation commerciale, reproduction ou distribution sans autorisation écrite préalable est strictement interdite.'
    },
    {
      title: '9. Données Personnelles',
      content: 'Les informations collectées lors de la commande sont nécessaires au traitement de celle-ci. Conformément au RGPD, le client dispose d\'un droit d\'accès, de rectification et de suppression de ses données. Pour plus d\'informations, consultez notre Politique de Confidentialité.'
    },
    {
      title: '10. Responsabilité',
      content: 'Pixel-anim s\'engage à fournir des créations de qualité professionnelle. Notre responsabilité ne saurait être engagée en cas de force majeure ou d\'informations erronées fournies par le client. Les créations sont fournies "en l\'état" et Pixel-anim ne garantit pas qu\'elles répondront à tous les besoins spécifiques du client.'
    },
    {
      title: '11. Réclamations',
      content: 'Toute réclamation doit être adressée par email à contact@pixel-anim.com dans les 7 jours suivant la livraison. Nous nous engageons à répondre dans un délai de 48 heures et à trouver une solution satisfaisante dans les meilleurs délais.'
    },
    {
      title: '12. Loi Applicable',
      content: 'Les présentes CGV sont soumises au droit français. En cas de litige, et après tentative de résolution amiable, les tribunaux français seront seuls compétents.'
    }
  ];

  return (
    <div className="min-h-screen bg-white">
      <Navbar />

      {/* Hero Section */}
      <section className="pt-32 pb-16 bg-gradient-to-br from-blue-50 via-purple-50 to-pink-50">
        <div className="max-w-7xl mx-auto px-6">
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
            className="text-center"
          >
            <h1 className="text-5xl md:text-6xl font-fredoka font-bold text-gray-900 mb-6">
              Conditions Générales de{' '}
              <span className="bg-gradient-to-r from-primary-blue via-purple-600 to-primary-coral bg-clip-text text-transparent">
                Vente
              </span>
            </h1>
            <p className="text-lg font-quicksand text-gray-600 max-w-3xl mx-auto">
              Dernière mise à jour : Janvier 2025
            </p>
          </motion.div>
        </div>
      </section>

      {/* Content Section */}
      <section className="py-24">
        <div className="max-w-4xl mx-auto px-6">
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: 0.2 }}
            className="bg-white rounded-4xl p-8 md:p-12 shadow-soft border border-gray-100"
          >
            <div className="space-y-8">
              {sections.map((section, index) => (
                <motion.div
                  key={index}
                  initial={{ opacity: 0, y: 20 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  viewport={{ once: true }}
                  transition={{ duration: 0.5, delay: index * 0.05 }}
                  className="border-b border-gray-100 pb-6 last:border-b-0"
                >
                  <h2 className="text-2xl font-fredoka font-bold text-gray-900 mb-4">
                    {section.title}
                  </h2>
                  <p className="font-quicksand text-gray-700 leading-relaxed">
                    {section.content}
                  </p>
                </motion.div>
              ))}
            </div>

            {/* Contact Info */}
            <motion.div
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5 }}
              className="mt-12 p-6 bg-gradient-to-br from-primary-mint/20 to-green-100 rounded-3xl"
            >
              <h3 className="text-xl font-fredoka font-bold text-gray-900 mb-3">
                Des questions sur nos CGV ?
              </h3>
              <p className="font-quicksand text-gray-700 mb-4">
                Notre équipe est à votre disposition pour répondre à toutes vos questions concernant nos conditions générales de vente.
              </p>
              <a
                href="/contact"
                className="inline-flex items-center gap-2 px-6 py-3 bg-gray-900 text-white font-quicksand font-semibold rounded-full hover:bg-gray-800 transition-all duration-300 whitespace-nowrap cursor-pointer"
              >
                <i className="ri-mail-line"></i>
                <span>Nous contacter</span>
              </a>
            </motion.div>
          </motion.div>
        </div>
      </section>

      <Footer />
    </div>
  );
}
